export class NetzbetreiberFilter {
    constructor(
        public name?: string,
        public stwId?: string,
        public teilgebiet?: string,
        public netzbetreibernummer?: string,
        public geschaeftspartnerId?: string,
        public lastImportDate?: {
            start: string,
            end: string,
        },
        public dienstleistungsart?: string,
        public dienstleistungsmoduleBeschreibung?: string[],
    ) {
    }
}

